import { StaffActivitiesByDescription } from "../../types";

export const staffActivities: StaffActivitiesByDescription = {
  "Indiana Invoice": {
    parameters: {
      linkUrls: ["https://tier2.dhs.in.gov/Account/Login.aspx"],
      staffInputs: {
        fees: true,
        documentTypes: {
          invoice: true,
          receipt: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Invoice",
    consolidated: "Once Per Credential",
    state: "IN",
  },
  "Indiana State Portal": {
    parameters: {
      linkUrls: ["https://tier2.dhs.in.gov/Account/Login.aspx"],
      staffInputs: {
        fees: false,
        documentTypes: {
          invoice: false,
          receipt: false,
          report: true,
        },
      },
    },
    jurisdictionType: "State",
    activityType: "Portal",
    state: "IN",
  },
};
